import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { useId } from 'react-id-generator';
import styled from 'styled-components';
import { spacing1x, spacing2x, spacing6x } from '../../styles/spacing.js';
import { LabelWrapper, FormFieldLabel } from '../FormFieldLabel/FormFieldLabel.js';
import '../Icons/IconActivity.js';
import '../Icons/IconActivityFilled.js';
import '../Icons/IconActivityOff.js';
import '../Icons/IconAdd.js';
import '../Icons/IconAddToCart.js';
import '../Icons/IconAlignBottom.js';
import '../Icons/IconAlignCenter.js';
import '../Icons/IconAlignJustify.js';
import '../Icons/IconAlignLeft.js';
import '../Icons/IconAlignMiddle.js';
import '../Icons/IconAlignRight.js';
import '../Icons/IconAlignTop.js';
import '../Icons/IconAnnotate.js';
import '../Icons/IconApps.js';
import '../Icons/IconArchive.js';
import '../Icons/IconArrowBack.js';
import '../Icons/IconArrowDown.js';
import '../Icons/IconArrowLeft.js';
import '../Icons/IconArrowRight.js';
import '../Icons/IconArrowUp.js';
import '../Icons/IconAskExpert.js';
import '../Icons/IconAtMention.js';
import '../Icons/IconAttach.js';
import '../Icons/IconBarChart.js';
import '../Icons/IconBold.js';
import '../Icons/IconCalendar.js';
import '../Icons/IconCalendarDay.js';
import '../Icons/IconCaretDown.js';
import '../Icons/IconCaretUp.js';
import '../Icons/IconCertification.js';
import '../Icons/IconCheck.js';
import '../Icons/IconClose.js';
import '../Icons/IconCloseContextualPanel.js';
import '../Icons/IconCloudSync.js';
import '../Icons/IconCloudUpload.js';
import '../Icons/IconCode.js';
import '../Icons/IconCollapsePanel.js';
import '../Icons/IconCollection.js';
import '../Icons/IconColor.js';
import '../Icons/IconColumns.js';
import '../Icons/IconComment.js';
import '../Icons/IconContentPlanner.js';
import '../Icons/IconCopy.js';
import '../Icons/IconCorporations.js';
import '../Icons/IconCRM.js';
import '../Icons/IconCustomDelivery.js';
import '../Icons/IconCustomize.js';
import '../Icons/IconDash.js';
import '../Icons/IconDatasource.js';
import '../Icons/IconDelete.js';
import '../Icons/IconDependentField.js';
import '../Icons/IconDocCenter.js';
import '../Icons/IconDownload.js';
import '../Icons/IconDrag.js';
import '../Icons/IconEdit.js';
import '../Icons/IconEditForm.js';
import '../Icons/IconEditNew.js';
import '../Icons/IconEmail.js';
import '../Icons/IconEmailBlast.js';
import '../Icons/IconEmailComponent.js';
import '../Icons/IconEmailTemplate.js';
import '../Icons/IconEmoji.js';
import '../Icons/IconEngagements.js';
import '../Icons/IconEvent.js';
import '../Icons/IconExpire.js';
import '../Icons/IconExport.js';
import '../Icons/IconExternal.js';
import '../Icons/IconFavoriteSelected.js';
import '../Icons/IconFavoriteUnselected.js';
import '../Icons/IconFile.js';
import '../Icons/IconFileAdd.js';
import '../Icons/IconFileEdit.js';
import '../Icons/IconFileLock.js';
import '../Icons/IconFileMove.js';
import '../Icons/IconFileRemove.js';
import '../Icons/IconFileSearch.js';
import '../Icons/IconFileShare.js';
import '../Icons/IconFileStar.js';
import '../Icons/IconFileSync.js';
import '../Icons/IconFileZip.js';
import '../Icons/IconFilter.js';
import '../Icons/IconFolder.js';
import '../Icons/IconFolderAdd.js';
import '../Icons/IconFolderEdit.js';
import '../Icons/IconFolderOpen.js';
import '../Icons/IconFolderRemove.js';
import '../Icons/IconFolderSearch.js';
import '../Icons/IconFolderShare.js';
import '../Icons/IconFolderStar.js';
import '../Icons/IconFolderSync.js';
import '../Icons/IconFolderTeam.js';
import '../Icons/IconFolderZip.js';
import '../Icons/IconFullscreen.js';
import '../Icons/IconGenericSort.js';
import '../Icons/IconGlobal.js';
import '../Icons/IconGoogleDrive.js';
import '../Icons/IconGrid.js';
import '../Icons/IconGridPattern1.js';
import '../Icons/IconGroupBy.js';
import '../Icons/IconHandClosed.js';
import '../Icons/IconHandOpen.js';
import '../Icons/IconHome.js';
import '../Icons/IconIndentDecrease.js';
import '../Icons/IconIndentIncrease.js';
import '../Icons/IconInsights.js';
import '../Icons/IconIntegrations.js';
import '../Icons/IconInternalSync.js';
import '../Icons/IconItalic.js';
import '../Icons/IconLaptop.js';
import '../Icons/IconLayout.js';
import '../Icons/IconLearningJourney.js';
import '../Icons/IconLesson.js';
import '../Icons/IconLibrary.js';
import '../Icons/IconLightbulb.js';
import '../Icons/IconLike.js';
import '../Icons/IconLikeDisabled.js';
import '../Icons/IconLineChart.js';
import '../Icons/IconLineHeight.js';
import '../Icons/IconLink.js';
import '../Icons/IconList.js';
import '../Icons/IconListNumbers.js';
import '../Icons/IconLiveSocial.js';
import '../Icons/IconLocate.js';
import '../Icons/IconLock.js';
import '../Icons/IconLogic.js';
import '../Icons/IconMedia.js';
import '../Icons/IconMediaCC.js';
import '../Icons/IconMediaCCActive.js';
import '../Icons/IconMediaControlPrevious.js';
import '../Icons/IconMediaForward.js';
import '../Icons/IconMediaFull.js';
import '../Icons/IconMediaLow.js';
import '../Icons/IconMediaMedium.js';
import '../Icons/IconMediaMute.js';
import '../Icons/IconMediaNext.js';
import '../Icons/IconMediaPause.js';
import '../Icons/IconMediaPlay.js';
import '../Icons/IconMediaRewind.js';
import '../Icons/IconMediaStop.js';
import '../Icons/IconMeetings.js';
import '../Icons/IconMenu.js';
import '../Icons/IconModule.js';
import '../Icons/IconMore.js';
import '../Icons/IconMove.js';
import '../Icons/IconMultiSelect.js';
import '../Icons/IconNews.js';
import '../Icons/IconNumeric.js';
import '../Icons/IconOpenContextualPanel.js';
import '../Icons/IconOpenPanel.js';
import '../Icons/IconPage.js';
import '../Icons/IconPageBack.js';
import '../Icons/IconPageDown.js';
import '../Icons/IconPageForward.js';
import '../Icons/IconPageUp.js';
import '../Icons/IconPaperclip.js';
import '../Icons/IconParagraph.js';
import '../Icons/IconPath.js';
import '../Icons/IconPieChart.js';
import '../Icons/IconPin.js';
import '../Icons/IconPortfolio.js';
import '../Icons/IconPresentation.js';
import '../Icons/IconPresentationMode.js';
import '../Icons/IconPreview.js';
import '../Icons/IconPreviewOff.js';
import '../Icons/IconPrint.js';
import '../Icons/IconProject.js';
import '../Icons/IconPublish.js';
import '../Icons/IconPublishing.js';
import '../Icons/IconPushNotification.js';
import '../Icons/IconPuzzlePiece.js';
import '../Icons/IconQuote.js';
import '../Icons/IconRecord.js';
import '../Icons/IconRecordActive.js';
import '../Icons/IconRedo.js';
import '../Icons/IconRefresh.js';
import '../Icons/IconRemoveFormatting.js';
import '../Icons/IconReorder.js';
import '../Icons/IconRequest.js';
import '../Icons/IconRotate.js';
import '../Icons/IconRSS.js';
import '../Icons/IconSave.js';
import '../Icons/IconScreen.js';
import '../Icons/IconScreenFitHeight.js';
import '../Icons/IconScreenFitWidth.js';
import '../Icons/IconScreenNext.js';
import '../Icons/IconScreenPrevious.js';
import '../Icons/IconScreenShare.js';
import '../Icons/IconSearch.js';
import '../Icons/IconSettings.js';
import '../Icons/IconShare.js';
import '../Icons/IconSharedLink.js';
import '../Icons/IconSingleSelect.js';
import '../Icons/IconSortDown.js';
import '../Icons/IconSortUp.js';
import '../Icons/IconSoundOff.js';
import '../Icons/IconSoundOn.js';
import '../Icons/IconStatusAdd.js';
import '../Icons/IconStatusAddFilled.js';
import { IconStatusCheck } from '../Icons/IconStatusCheck.js';
import '../Icons/IconStatusCheckFilled.js';
import '../Icons/IconStatusClose.js';
import '../Icons/IconStatusCloseFilled.js';
import '../Icons/IconStatusDot.js';
import '../Icons/IconStatusError.js';
import '../Icons/IconStatusHelp.js';
import '../Icons/IconStatusHelpFilled.js';
import '../Icons/IconStatusInformation.js';
import '../Icons/IconStatusInformationFilled.js';
import '../Icons/IconStatusPause.js';
import '../Icons/IconStatusPauseFilled.js';
import '../Icons/IconStatusPlay.js';
import '../Icons/IconStatusPlayFilled.js';
import '../Icons/IconStatusRemove.js';
import '../Icons/IconStatusRemoveFilled.js';
import { IconStatusUrgent } from '../Icons/IconStatusUrgent.js';
import '../Icons/IconStatusUrgentFilled.js';
import '../Icons/IconStatusWarning.js';
import '../Icons/IconSubtask.js';
import '../Icons/IconSync.js';
import '../Icons/IconTableColumn.js';
import '../Icons/IconTableGrid.js';
import '../Icons/IconTableRow.js';
import '../Icons/IconTags.js';
import '../Icons/IconTask.js';
import '../Icons/IconTasks.js';
import '../Icons/IconTaxonomy.js';
import '../Icons/IconTemplate.js';
import '../Icons/IconText.js';
import '../Icons/IconTextCleared.js';
import '../Icons/IconTextField.js';
import '../Icons/IconTextImageLeft.js';
import '../Icons/IconTextImageRight.js';
import '../Icons/IconTextIndentLeft.js';
import '../Icons/IconTextIndentRight.js';
import '../Icons/IconTextSingle.js';
import '../Icons/IconTextSize.js';
import '../Icons/IconTextStrikethrough.js';
import '../Icons/IconTextSubscript.js';
import '../Icons/IconTextSuperscript.js';
import '../Icons/IconTextUnderline.js';
import '../Icons/IconTrendingDown.js';
import '../Icons/IconTrendingUp.js';
import '../Icons/IconTrueFalse.js';
import '../Icons/IconTv.js';
import '../Icons/IconTwoColumn.js';
import '../Icons/IconUndo.js';
import '../Icons/IconUnlike.js';
import '../Icons/IconUnlink.js';
import '../Icons/IconUnlock.js';
import '../Icons/IconUnpublish.js';
import '../Icons/IconUpload.js';
import '../Icons/IconUser.js';
import '../Icons/IconUserAdd.js';
import '../Icons/IconUserAddToMeeting.js';
import '../Icons/IconUserGroup.js';
import '../Icons/IconUserRating.js';
import '../Icons/IconUserRemove.js';
import '../Icons/IconUserSearch.js';
import '../Icons/IconUserSettings.js';
import '../Icons/IconUserShare.js';
import '../Icons/IconUserSync.js';
import '../Icons/IconVariables.js';
import '../Icons/IconVideo.js';
import '../Icons/IconVideoPause.js';
import '../Icons/IconVideoRewind15.js';
import '../Icons/IconVideoSkip15.js';
import '../Icons/IconWorkspace.js';
import '../Icons/IconZoomIn.js';
import '../Icons/IconZoomOut.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var defaultElement = "div";
var FormFieldInputWrapper = styled.div.withConfig({
  displayName: "FormField__FormFieldInputWrapper",
  componentId: "sc-1yill90-0"
})(["&&{grid-area:control;}&& *[data-css-selector='inputContainer']{width:100%;}"]);
var FormFieldAlert = styled.div.withConfig({
  displayName: "FormField__FormFieldAlert",
  componentId: "sc-1yill90-1"
})(["&&{margin-top:", ";color:", ";font-size:12px;font-weight:bold;grid-area:alert;line-height:24px;margin-inline-start:", ";}&& > svg{margin-inline-end:", ";vertical-align:text-top;}"], spacing1x, function (props) {
  return props.isSuccess ? props.theme.alertColors.success : props.theme.alertColors.error;
}, spacing2x, spacing2x);
var FormFieldDescription = styled.div.withConfig({
  displayName: "FormField__FormFieldDescription",
  componentId: "sc-1yill90-2"
})(["&&{margin-bottom:", ";color:", ";font-size:12px;grid-area:description;line-height:16px;text-overflow:ellipsis;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;white-space:normal;}"], spacing1x, function (props) {
  return props.theme.neutralColors.smoke;
});
var FormFieldContainer = styled.div.withConfig({
  displayName: "FormField__FormFieldContainer",
  componentId: "sc-1yill90-3"
})(["&&{column-gap:", ";display:grid;grid-template-columns:auto;grid-template-areas:'label' 'description' 'control' 'alert';width:100%;margin-bottom:", ";", ";}&& ", "{grid-area:label;}"], spacing6x, spacing2x, function (props) {
  return props.$inline && "\n        @media (min-width: 1140px) {\n            grid-template-columns: minmax(100px, 25%) 1fr;\n            grid-template-areas:\n                'label control'\n                '. alert';\n            ".concat(FormFieldDescription, " {\n                display: none;\n            }\n        };\n    ");
}, LabelWrapper);
var FormField = /*#__PURE__*/React.forwardRef(function FormField2(props, ref) {
  var _props$as = props.as,
    as = _props$as === void 0 ? defaultElement : _props$as,
    children = props.children,
    className = props.className,
    controlId = props.controlId,
    description = props.description,
    error = props.error,
    _props$formId = props.formId,
    formId = _props$formId === void 0 ? "form-1" : _props$formId,
    inline = props.inline,
    label = props.label,
    labelProps = props.labelProps,
    required = props.required,
    success = props.success;
  var _useId = useId(1, formId + "-field-"),
    _useId2 = _slicedToArray(_useId, 1),
    uniqId = _useId2[0];
  var id = controlId || uniqId;
  return /*#__PURE__*/jsxs(FormFieldContainer, {
    as: as,
    className: className,
    $inline: inline,
    ref: ref,
    children: [/*#__PURE__*/jsx(FormFieldLabel, _objectSpread(_objectSpread({}, labelProps), {}, {
      as: as === "fieldset" ? "legend" : void 0,
      htmlFor: id,
      required: required,
      children: label
    })), description && /*#__PURE__*/jsx(FormFieldDescription, {
      children: description
    }), /*#__PURE__*/jsx(FormFieldInputWrapper, {
      children: typeof children === "function" ? children(id) : /*#__PURE__*/React.isValidElement(children) && React.Children.only(children) && typeof children !== "string" ? /*#__PURE__*/React.cloneElement(children, {
        id: id
      }) : children
    }), (typeof error === "string" || typeof success === "string") && /*#__PURE__*/jsxs(FormFieldAlert, {
      isSuccess: !!success,
      role: error ? "alert" : "status",
      children: [error ? /*#__PURE__*/jsx(IconStatusUrgent, {
        size: 16
      }) : /*#__PURE__*/jsx(IconStatusCheck, {
        size: 16
      }), /*#__PURE__*/jsx("span", {
        children: error || success
      })]
    })]
  });
});
FormField.displayName = "FormField";

export { FormField, defaultElement };
